import _ from 'lodash';
import EstimationWorker from '../../../components/workers/EstimationWorker';

export default async (taskId, ganttId, resourceId, value = null, valuePerDay = null, resourcesList) => {
  const item = resourcesList.find(resource => resource.resource_id === resourceId);

  if (!item) {
    return resourcesList;
  }

  const tasksResourcesToEstimate = [{
    task_id: +taskId,
    gantt_id: +ganttId,
    resources: [{ resource_id: item.resource_id, value, valuePerDay }],
  }];

  const estimationWorkerData = await EstimationWorker.calculate(tasksResourcesToEstimate, 'changeTasks', 'updateTasksResourceEstimations');

  return resourcesList.map(resource => {
    const resourceEstimation = _.get(estimationWorkerData.diff.resourceEstimations, [taskId, resource.resource_id]);

    if (resourceEstimation) {
      resource.value = resourceEstimation.value;
      resource.valuePerDay = resourceEstimation.valuePerDay;
    } else if (resource.resource_id === item.resource_id) {
      resource.value = value;
      resource.valuePerDay = valuePerDay;
    }

    return resource;
  });
};
